import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ArrowDown = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8669 8.98267C13.0444 9.15004 13.0444 9.42139 12.8669 9.58876L8.32141 13.8745C8.1439 14.0418 7.8561 14.0418 7.67859 13.8745L3.13313 9.58876C2.95562 9.42139 2.95562 9.15004 3.13313 8.98267C3.31064 8.8153 3.59844 8.8153 3.77596 8.98267L7.54545 12.5368L7.54545 2.42857C7.54545 2.19188 7.74896 2 8 2C8.25104 2 8.45455 2.19188 8.45455 2.42857L8.45454 12.5368L12.224 8.98267C12.4016 8.8153 12.6894 8.8153 12.8669 8.98267Z"
        fill={color}
      />
    </svg>
  )
})

export default ArrowDown
